// TODO Should rename file as 'observation'
import { createActionBundle } from 'utilities/request';

export const {
  request: requestNewestObservation,
  success: requestNewestObservationSuccess,
  failure: requestNewestObservationFailure,
} = createActionBundle('NEWEST_OBSERVATION');
